module.exports = __webpack_public_path__ + "img/jens_mossler.7dd54372.png";